import { Component, ViewChild, OnInit, Input, ElementRef } from '@angular/core';
// @ts-ignore
import ImageEditor from 'tui-image-editor';
import { ImageannotationModel } from '../../models/Imageannotation';

@Component({
  selector: 'app-tui-image-editor-wrapper',
  templateUrl: './tui-image-editor-wrapper.component.html',
  styleUrls: ['./tui-image-editor-wrapper.component.css']
})
export class TuiImageEditorWrapperComponent implements OnInit {
  @Input() public imageannotationModel: ImageannotationModel = new ImageannotationModel();
  @ViewChild('container') container: ElementRef;
  ImageEditorElement;
  constructor() { }
  ngOnInit() { }

  ngAfterViewInit() {
    this.ImageEditorElement = new ImageEditor(this.container.nativeElement, {
      includeUI: {
        theme: {
          'menu.normalIcon.path': './assets/images/svg/icon-d.svg',
          'menu.activeIcon.path': './assets/images/svg/icon-b.svg',
          // @ts-ignore
          'menu.disabledIcon.path': './assets/images/svg/icon-a.svg',
          'menu.hoverIcon.path': './assets/images/svg/icon-c.svg',
          'submenu.normalIcon.path': './assets/images/svg/icon-d.svg',
          'submenu.activeIcon.path': './assets/images/svg/icon-c.svg',
        },
       // cssMaxWidth: 700,
        //cssMaxHeight: 900,
        usageStatistics: false
      },
    }
    );
  }
  onSaveImage() {
    //console.log(this.ImageEditorElement.toDataURL());
    this.imageannotationModel.annotedbase64Image = this.ImageEditorElement.toDataURL();
    //console.log(this.ImageEditorElement.getImageName());
    this.imageannotationModel.imageName = this.ImageEditorElement.getImageName();
    this.imageannotationModel.imageType = this.imageannotationModel.imageName.split('.').pop();
    this.ngAfterViewInit();
  }
}
